// Temporary restriction: set REACT_APP_LIMITED_MODE=true in .env to enable.
// Set to false or remove the variable to restore full access.
export const LIMITED_MODE_ENABLED =
  process.env.REACT_APP_LIMITED_MODE === 'true'

export const LIMITED_MODE_ALLOWED_ROUTES = ['/receipt', '/sales-report'] as const

export const LIMITED_MODE_ALWAYS_ALLOWED_ROUTES = ['/sign-out'] as const

export const LIMITED_MODE_DEFAULT_ROUTE = '/receipt'

export const isRouteAllowed = (routeName: string): boolean => {
  if (!LIMITED_MODE_ENABLED) return true

  return (
    LIMITED_MODE_ALLOWED_ROUTES.includes(
      routeName as (typeof LIMITED_MODE_ALLOWED_ROUTES)[number]
    ) ||
    LIMITED_MODE_ALWAYS_ALLOWED_ROUTES.includes(
      routeName as (typeof LIMITED_MODE_ALWAYS_ALLOWED_ROUTES)[number]
    )
  )
}
